import en_messages from './en';
import fi_messages from './fi';
import sv_messages from './sv';

const localeMessages = { 'en' : en_messages, 'fi' : fi_messages, 'sv' : sv_messages};

module.exports = localeMessages;



// WEBPACK FOOTER //
// ./locales/index.js